<template>
  <div class="breadcrumb-wrapper">
    <div class="breadcrumb">
      <a v-for="(name, index) in historyNames" :key="name" @click.prevent="routeTo(name)" class="breadcrumb-item" v-bind:class="{'active': active(index)}" href="#">
        <span class="breadcrumb-index" v-if="showIndex">{{ index + 1 }}</span>
        {{$t(`routing.${name}`)}}
      </a>
    </div>
  </div>
</template>

<script>
import messages from './Routing.names'
export default {
  name: 'Breadcrumbs',
  props: {
    showIndex: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    history () {
      return this.$breadcrumbs.history
    },
    historyNames () {
      return this.history.map(i => this.$breadcrumbs.getName(i))
    }
  },
  methods: {
    active (index) {
      return !this.notLastItem(index)
    },
    routeTo (name) {
      this.$router.push({ name })
    },
    notLastItem (index) {
      return index < this.historyNames.length - 1
    }
  },
  i18n: {messages}
}
</script>
<style scoped lang="scss">
@import '../../../assets/scss/shipbob-custom/components/layout/_breadcrumbs.scss';
</style>